import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { PermissionStore } from "./Store/Variables";

export const checkPermission = (userClaim: UserClaim | UserClaim[]): boolean => {
    let flag = true;
    if (Array.isArray(userClaim)) {
        flag = userClaim.some((x) => PermissionStore.getData().includes(x));
    } else {
        flag = PermissionStore.getData().includes(userClaim);
    }
    return flag;
};
